module.exports = __webpack_public_path__ + "img/about-values-video.jpg?8c7f793ac1c4dea5645eb9ee109d198f";